import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { useThemeSync } from './store/themeStore';

// Pages
import Login from './pages/Login';
import OAuthCallback from './pages/OAuthCallback';
import MagicLinkCallback from './pages/MagicLinkCallback';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import ContactDetail from './pages/ContactDetail';
import Settings from './pages/Settings';
import TagManager from './pages/TagManager';
import TemplateManager from './pages/TemplateManager';
import TeamDashboard from './pages/TeamDashboard';
import Campaigns from './pages/Campaigns';
import Help from './pages/Help';
import Debug from './pages/Debug';

// Layout
import Layout from './components/layout/Layout';

// Protected Route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-ondeck-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  // Sync theme with document
  useThemeSync();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<OAuthCallback />} />
      <Route path="/auth/magic" element={<MagicLinkCallback />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="contacts/:id" element={<ContactDetail />} />
        <Route path="tags" element={<TagManager />} />
        <Route path="templates" element={<TemplateManager />} />
        <Route path="team-dashboard" element={<TeamDashboard />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="settings" element={<Settings />} />
        <Route path="help" element={<Help />} />
        <Route path="debug" element={<Debug />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
